module.exports = __webpack_public_path__ + "static/img/purple-msg.402189e6.png";